import React from "react";
import { useSelector } from "react-redux";

const NavBarDropdown = props => {
  const { isOpen, children, displayedName } = props;

  const clientSettings = useSelector(state => state.common.clientSettings);

  return (
    isOpen && (
      <div>
        {clientSettings.newUIFlag && (
          <span className="profile-displayName_nav">{displayedName}</span>
        )}
        <ul className="apl-drop-menu__list" aria-label="submenu">
          {children}
        </ul>
      </div>
    )
  );
};

export default NavBarDropdown;



// WEBPACK FOOTER //
// ./components/common/navigation/NavBarDropdown.js